export default __webpack_public_path__ + "static/media/highspeed_line_logo_1024.75a20ff4.png";